import React from "react";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TabPanel from "./tabPanel";
import {AppBar} from "@material-ui/core";

class LangTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value : 0,
            langChilds : this.props.langChilds ? this.props.langChilds : [],
            disableInputs : this.props.disableInputs,
            orientation : this.props.orientation
        }
        this.setValue = this.setValue.bind(this);
    }

    setValue(value){
        this.setState({
            value
        })
    }

    getDynamicProps(index) {
        if (this.state.orientation === 'vertical')
            return {
                id: `vertical-tab-${index}`,
                'aria-controls': `vertical-tabpanel-${index}`,
            };
        else
            return {
                id: `horizontal-tab-${index}`,
                'aria-controls': `horizontal-tabpanel-${index}`,
            };
    }

    render() {

        const handleChange = (event, newValue) => {
            this.setValue(newValue);
        };

        const langChilds = this.props.getLangChilds();

        // style={{'flexGrow': '1', 'display': 'flex'}}
        return (
                <div style={this.state.orientation === 'vertical' ? {'flexGrow': '1', 'display': 'flex'} : {}} >
                {/* ----------------------------------------------------------------*/}
                {/*           El encabezado (izquierdo) del TabControl              */}
                {/* ----------------------------------------------------------------*/}
                {
                    this.state.orientation === 'vertical' &&
                    <Tabs
                        orientation="vertical"
                        variant="scrollable"
                        value={this.state.value}
                        onChange={handleChange}
                        aria-label=""
                        style={{'borderRight': '1px solid'}}
                    >
                        {
                            langChilds.map((child, index) => {
                                return( <Tab
                                    key={`Tab${index}`}
                                    label={child?.lang?.name}
                                    {...this.getDynamicProps(index)}
                                /> )
                            })
                        }
                        {/* ----------------------------------------------------------------*/}
                        {/*                  Los paneles de cada Tab                        */}
                        {/* ----------------------------------------------------------------*/}
                    </Tabs>
                }
                {
                    this.state.orientation === 'horizontal' &&
                    <AppBar position="static">
                        <Tabs
                            value={this.state.value}
                            onChange={handleChange}
                            aria-label=""
                        >
                            {
                                langChilds.map((child, index) => {
                                    return( <Tab
                                        key={`Tab${index}`}
                                        label={child?.lang?.name}
                                        {...this.getDynamicProps(index)}
                                    /> )
                                })
                            }
                            {/* ----------------------------------------------------------------*/}
                            {/*                  Los paneles de cada Tab                        */}
                            {/* ----------------------------------------------------------------*/}
                        </Tabs>
                    </AppBar>
                }
                {
                    langChilds.map((child, index) => {
                        return(
                            <TabPanel value={this.state.value} index={index} key={`TabPanel${index}`}>
                                {this.props.getFormulary(child, index, this.props.disableInputs, this.props.onInputChange)}
                            </TabPanel>
                        )
                    })
                }
            </div>
        );
    }

}

export default LangTab
